// import '../util/m-base'

import '../../css/reset.css'
import './index.less'
import about1 from './img/about-1.png'
import about2 from './img/about-2.png'
import about3 from './img/about-3.png'

const temp = `
<header>
    <p><span>Beijing Fanle Technology</span></p>
    <h1>Committed to bringing high-quality Internet innovative products and services to global users</h1>
</header>
<div class="content">
    <div class="about">
        <h2>Company Introduction</h2>
        <p>The company currently has 30 employees and a professional team composed of industry elites. The core team brings together outstanding talents from many first-class social companies at home and abroad. They have rich experience, superb technology and keen market insight, and continue to promote the development and progress of the company, and continue to provide high-quality experience for users in China and around the world.</p>
    </div>
    <div class="about-item">
        <div class="about-item-img">
            <img src="${about1}" alt="">
        </div>
        <div class="about-item-text">
            <h2>High-quality products and services</h2>
            <p>In terms of accuracy, we will repeatedly verify all kinds of information and cooperate with third-party information security service platforms such as Shumei. We continue to optimize the content review process and introduce advanced technical means to assist the review work. Through the intelligent algorithm, the content is preliminarily screened, which improves the efficiency of the review and further reduces the error rate. The pursuit of professionalism also runs through the review. From the in-depth analysis of technical documents to the unique insights of market analysis, we examine every expression with a professional eye, from the standardization of language expression to the accuracy of industry terms, from the rationality of typesetting layout to the coordination of pictures and texts, we will strictly control. Legality review cannot be sloppy. Strictly abide by national laws and regulations and Internet specifications, and strictly screen all content. Any content that may involve violations of laws and regulations will be resolutely intercepted to create a safe and secure browsing environment for users.</p>
        </div>
    </div>
    <div class="about-item">
        <div class="about-item-text">
            <h2>Perfect network information security technology</h2>
            <p>We adopt a multi-layer security strategy, from firewalls to intrusion detection systems, to provide all-round protection. We are equipped with professional maintenance personnel to monitor the system that provides services to users around the clock, and monitor and predict potential security threats in real time. We correctly handle user request services within the required time and reply to the user's request content to ensure that the content is accurate.</p>
            <p>We deploy advanced security solutions, such as data encryption storage, network access control, and security auditing, to effectively prevent various network threats and ensure the continuous and stable operation of the business.
            Use backup technology to improve the integrity of data recovery. The backup work can be done manually or automatically. Since the backup itself contains confidential information, the backup medium is also the target of thieves. Therefore, the computer system allows some special files of users to be backed up by confidential media instead of system backup.
            Use anti-virus, security patch programs, physical environment security, LAN firewall system, network security audit system, log analysis, encryption, information filtering and other means to ensure the security and stability of the network.</p>
        </div>
        <div class="about-item-img">
            <img src="${about2}" alt="">
        </div>
    </div>
    <div class="about-item">
        <div class="about-item-img">
            <img src="${about3}" alt="">
        </div>
        <div class="about-item-text">
            <h2>Reliable emergency response plan</h2>
            <p>We monitor users from a technical perspective through advanced monitoring tools. Once a problem is discovered, we can quickly identify security incidents and assess their severity and scope of impact. We maintain a legal and compliant environment and provide users with a healthy and orderly platform.</p>
        </div>
    </div>
</div>
<footer>
    <p>Beijing Fanle Technology Co.,Ltd.</p>
</footer>
`

document.querySelector('#wrap').innerHTML = temp


// WEBPACK FOOTER //
// ./js/index/index.js